import { render, staticRenderFns } from "./downloadAfter.vue?vue&type=template&id=24f40188&scoped=true"
import script from "./downloadAfter.vue?vue&type=script&lang=ts"
export * from "./downloadAfter.vue?vue&type=script&lang=ts"
import style0 from "./downloadAfter.vue?vue&type=style&index=0&id=24f40188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f40188",
  null
  
)

export default component.exports